import { render, staticRenderFns } from "./shop-purchase-ebuk.vue?vue&type=template&id=0e4c626f&scoped=true&"
import script from "./shop-purchase-ebuk.vue?vue&type=script&lang=js&"
export * from "./shop-purchase-ebuk.vue?vue&type=script&lang=js&"
import style0 from "./shop-purchase-ebuk.vue?vue&type=style&index=0&id=0e4c626f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e4c626f",
  null
  
)

export default component.exports